import React, { useEffect, useState, useContext } from 'react';
import {} from 'react-router-dom';
import { isAuthenticated, signinRedirect } from '../../services/authService';
import { useInterval } from '../../hooks/useInterval';
import { AppContext } from '../../AppContext';

const AppAuth: React.FC = (): React.ReactElement => {
  const { userManager, sessionExpires } = useContext(AppContext);
  const defaultDelay = 25000;
  const [isPaused, setPaused] = React.useState(false);
  const [count, setCount] = useState<number>(0);
  const [delay, setDelay] = useState<number | null>(defaultDelay);
  const [isADFSLogged] = useState<boolean>(isAuthenticated(userManager));

  const sessionisExpired = (exp: number | null) => {
    if (!exp) {
      return false;
    }
    return Date.now() < exp;
  };

  useInterval(
    () => {
      if (count < 36000) {
        console.log('expiry:',sessionExpires, sessionisExpired(sessionExpires));
        setCount(count + 1);
      } else {
        setDelay(null);
      }
    },
    isPaused ? null : delay
  );

  useEffect(() => {
    if(sessionisExpired(sessionExpires) && isADFSLogged) {
        signinRedirect(userManager);
        console.log('session expire status: ', sessionisExpired(sessionExpires));
    } else {
        console.log('session expire status: ', sessionisExpired(sessionExpires));
    }
  },[count]);

  useEffect(() => {
    !isADFSLogged && setPaused(true);
  }, [isADFSLogged]);

  useEffect(() => {
    isPaused
     ? setDelay(null) : setDelay(defaultDelay);
  }, [isPaused]);

  return <></>;
};

export default AppAuth;
